import {abortableAppRequest, appQuery, appRequest} from "./utils_request";
import {createBadge, createButton, createElement, createIcon, removeAllChild} from "./utils_element";
import {initCollection} from './form_collection'
import Viewer from 'viewerjs';
import SearchEngine from './search_engine';

const idCollectionEquipments = 'vehicle_folder_w3CVHEQUIPEMENTCollection';
const btnQuotation = document.getElementById('quotationVehicle');
const btnAdmin = document.getElementById('adminVehicle');
const btnShipping = document.getElementById('shippingVehicle');
const btnHistory = document.getElementById('historyVehicle');
const btnPhoto = document.getElementById('photosVehicle');
const btnNext = document.getElementById('btnNext');
const btnPrevious = document.getElementById('btnPrevious');

let activeTab = null,
    hasPhoto = false;


export const init = (sections, targetTab, vehicle, vehicleFolder) => {
    initTab(sections, targetTab);
    initFolderColor(vehicleFolder);
    initCollection(idCollectionEquipments, true);
    initEquipmentOrder();
    initEquipmentOrderListener();
    initVehiclePhotos(vehicle, vehicleFolder);
    initSearchEngine();
    initCsa(vehicle);
};

// SEARCH ENGINE //

const initSearchEngine = () => {
    const renderPertinence = (data) => {
        let icon = createElement('i', 'fad fa-circle');
        if (data >= 75) {
            icon.classList.add('text-success');
            return icon.outerHTML;
        }
        icon.classList.add('text-danger');
        return icon.outerHTML;
    };
    initSearchEngineHistory(renderPertinence);
    initSearchEngineModel(renderPertinence);
    initSearchEngineModelMine(renderPertinence);
    initSearchEngineArgus();
};

const initSearchEngineArgus = () => {
    let searchEngineOID = SearchEngine(document.getElementById('searchEngineOID'), {
        badgeFilter: false,
        urlData: urls.searchArgusOID,
        defaultValue: document.getElementById('vehicle_folder_vehicleQuotation_typeMine').value,
        modal: document.getElementById('searchEngineOID'),
        btnModal: document.getElementById('vehicle_folder_vehicleQuotation_defineArgusOID'),
        dataTableColumns: [
            {
                "className": 'details-control',
                "orderable": false,
                "data": null,
                "defaultContent": '<button type="button" class="btn"><i class="fa fa-plus"></i></button>'
            },
            {
                data: "typeMine"
            },
            {
                data: "typeCommercial",
            },
            {
                data: "regroupement"
            },
            {
                data: "puissance"
            },
            {
                data: "energie"
            },
            {
                data: "segment"
            },
            {
                data: "docEntry",
                visible: false
            }
        ]
    });

    $('#searchEngineOID tbody').on('click', 'td.details-control', function () {
        function format(data) {
            let tr = "";
            for (let i = 0; i < data['w3CMODELELIGNECollection'].length; i++){
                tr+="<tr " +
                    "class='line-oid-argus' " +
                    "data-model='" + JSON.stringify(data['w3CMODELELIGNECollection'][i]) + "'>" +
                    "<td>" + data['w3CMODELELIGNECollection'][i]['intituleArgus'] + "</td><td>" + data['w3CMODELELIGNECollection'][i]['oidArgus'] + "</td>" +
                    "</tr>";
            }

            return '<table style="padding-left:50px;" class="table table-hover cursor-pointer">' +
                tr
                + '</table>'
        }

        var tr = $(this).closest('tr');
        var row = $(searchEngineOID.table).DataTable().row(tr);
        if (row.child.isShown()) {
            // This row is already open - close it
            row.child.hide();
            tr.removeClass('shown');
            $(tr[0].querySelector('button')).html(createIcon("fa fa-plus"))
        } else {
            // Open this row
            row.child(format(row.data())).show();
            $('.line-oid-argus').on('click', (e) => {
                let tr = e.currentTarget;
                let oidArgus = JSON.parse(tr.dataset.model);
                let parentRow = $(e.currentTarget).parents('tr').prev();

                $('#oidArgusInput').val(oidArgus['oidArgus'] + ' - ' + oidArgus['intituleArgus']);
                $('#vehicle_folder_vehicleQuotation_oidArgus').val(oidArgus['oidArgus']).change();
                $('#vehicle_folder_vehicleQuotation_typeCommercial').val(parentRow.find('td:nth-child(3)').text()).change();
                $('#vehicle_folder_vehicleQuotation_regroupement').val(parentRow.find('td:nth-child(4)').text()).change();
                $('#vehicle_folder_vehicleQuotation_segment option[value="' + parentRow.find('td:nth-child(7)').text() + '"]')
                    .prop('selected', true);
                $('#vehicle_folder_vehicleQuotation_segment').change();
                $('#vehicle_folder_vehicleQuotation_docentryModele').val($(e.currentTarget).data()['model']['docEntry']);
                $(searchEngineOID.modal).modal('hide');
            });
            tr.addClass('shown');
            $(tr[0].querySelector('button')).html(createIcon("fa fa-minus"))
        }
    });
}

const initSearchEngineModel = (renderPertinence) => {
    let searchEngineModel = SearchEngine(document.getElementById('model'), {
        urlData: urls.searchVehicleModel,
        defaultValue: document.getElementById('vehicle_folder_vehicleQuotation_typeCommercial').value,
        modal: document.getElementById('model'),
        btnModal: document.getElementById('vehicle_folder_vehicleQuotation_defineModel'),
        dataTableColumns: [
            {
                data: "match",
                render: (data) => renderPertinence(data),
            },
            {
                data: "TypeCom",
            },
            {
                data: "Regroupement"
            },
            {
                data: "Puissance"
            },
            {
                data: "Energie"
            },
            {
                data: "TypeMine"
            },
            {
                data: "Segment"
            },
            {
                data: "DocEntry",
                visible: false
            },
            {
                data: "link",
                render : function ( data, type, row ) {
                    return '<btn type="button" class="btn btn-primary btn-sm py-1">Voir le modèle</btn>';
                }
            }
        ]
    });



    $('#model table tbody').on('click', 'tr', (e) => {
        let data = $(searchEngineModel.table).DataTable().row(e.currentTarget).data();
        if ($($(searchEngineModel.table).DataTable().column(e.target.parentNode).header()).html() === 'Lien SAP') {
            sap.sbo.webbridge.openForm('@W3C_MODELE', '' + data["DocEntry"]);
        } else {
            $('#vehicle_folder_vehicleQuotation_typeCommercial').val(data["TypeCom"]).change();
            $('#vehicle_folder_vehicleQuotation_regroupement').val(data["Regroupement"]).change();
            $('#vehicle_folder_vehicleQuotation_puissance').val(data["Puissance"]).change();
            $('#vehicle_folder_vehicleQuotation_energie option[value="' + data["Energie"] + '"]')
                .prop('selected', true);
            $('#vehicle_folder_vehicleQuotation_energie').change();
            $('#vehicle_folder_vehicleQuotation_typeMine').val(data["TypeMine"]).change();
            $('#vehicle_folder_vehicleQuotation_segment option[value="' + data["Segment"] + '"]')
                .prop('selected', true);
            $('#vehicle_folder_vehicleQuotation_segment').change();
            $('#vehicle_folder_vehicleQuotation_docentryModele').val(data["DocEntry"]);
            $(searchEngineModel.modal).modal('hide');
        }

    });
}

const initSearchEngineModelMine = (renderPertinence) => {
    let searchEngineModelMine = SearchEngine(document.getElementById('modelMine'), {
        urlData: urls.searchVehicleModelMine,
        defaultValue: document.getElementById('vehicle_folder_vehicleQuotation_typeMine').value,
        modal: document.getElementById('modelMine'),
        btnModal: document.getElementById('vehicle_folder_vehicleQuotation_defineModelMine'),
        dataTableColumns: [
            {
                data: "match",
                render: (data) => renderPertinence(data),
            },
            {
                data: "TypeCom",
            },
            {
                data: "Regroupement"
            },
            {
                data: "Puissance"
            },
            {
                data: "Energie"
            },
            {
                data: "TypeMine"
            },
            {
                data: "Segment"
            },
            {
                data: "DocEntry",
                visible: false
            },
            {
                data: "link",
                render : function ( data, type, row ) {
                    return '<btn type="button" class="btn btn-primary btn-sm py-1">Voir le modèle</btn>';
                }
            }
        ]
    });



    $('#modelMine table tbody').on('click', 'tr', (e) => {
        let data = $(searchEngineModelMine.table).DataTable().row(e.currentTarget).data();
        if ($($(searchEngineModelMine.table).DataTable().column(e.target.parentNode).header()).html() === 'Lien SAP') {
            sap.sbo.webbridge.openForm('@W3C_MODELE', '' + data["DocEntry"]);
        } else {
            $('#vehicle_folder_vehicleQuotation_typeCommercial').val(data["TypeCom"]).change();
            $('#vehicle_folder_vehicleQuotation_regroupement').val(data["Regroupement"]).change();
            $('#vehicle_folder_vehicleQuotation_puissance').val(data["Puissance"]).change();
            $('#vehicle_folder_vehicleQuotation_energie option[value="' + data["Energie"] + '"]')
                .prop('selected', true);
            $('#vehicle_folder_vehicleQuotation_energie').change();
            $('#vehicle_folder_vehicleQuotation_typeMine').val(data["TypeMine"]).change();
            $('#vehicle_folder_vehicleQuotation_segment option[value="' + data["Segment"] + '"]')
                .prop('selected', true);
            $('#vehicle_folder_vehicleQuotation_segment').change();
            $('#vehicle_folder_vehicleQuotation_docentryModele').val(data["DocEntry"]);
            $(searchEngineModelMine.modal).modal('hide');
        }

    });
}

const initSearchEngineHistory = (renderPertinence) => {
    let searchEngineSoldHistory = SearchEngine(document.getElementById('history'), {
        urlData: urls.searchVehicleSoldHistory,
        inputField: document.getElementById('vehicle_folder_vehicleQuotation_typeCommercial'),
        defaultValue: document.getElementById('vehicle_folder_vehicleQuotation_typeCommercial').value,
        modal: document.getElementById('history'),
        btnModal: document.getElementById('vehicle_folder_estimationQuotation_estimationVehicle'),
        dataTableColumns: [
            {
                data: "match",
                render: (data) => renderPertinence(data)
            },
            {
                data: "DateDebutVente",
                render: (data) => {
                    let date = new Date(data);
                    return date.toLocaleDateString(
                        "fr-FR",
                        {year: "numeric", month: "2-digit", day: "2-digit"}
                    );
                }
            },
            {
                data: "TypeComm"
            },
            {
                data: "Couleur"
            },
            {
                data: "DatePMEC",
                render: (data) => {
                    let date = new Date(data);
                    return date.toLocaleDateString("fr-FR", {year: 'numeric', month: '2-digit',});
                }
            },
            {
                data: "KilomReel",
                render: (data) => {
                    return Number(data).toLocaleString("fr-FR");
                }
            },
            {
                data: "CotePersoCotation",
                render: (data) => {
                    return Number(data).toLocaleString("fr-FR");
                }
            },
            {
                data: "CoteKiloCotation",
                render: (data) => {
                    return Number(data).toLocaleString("fr-FR");
                }
            },
            {
                data: "PrixAdjudication",
                render: (data) => {
                    return Number(data).toLocaleString("fr-FR");
                }
            },
            {
                data: "RatioAdjCk"
            },
            {
                data: "FraisRemiseEnEtat",
                render: (data) => {
                    return Number(data).toLocaleString("fr-FR");
                }
            },
            {
                data: "ObservationVendeur"
            },
            {
                data: "NoteVisuelle"
            },
            {
                data: "NoteInterieur"
            },
            {
                data: "NoteExpertise"
            },
            {
                render: () => {
                    let btn = createButton('btn open-iframe', '', 'fad fa-car');
                    btn.type = 'button';
                    return btn.outerHTML;
                }
            }
        ]
    });

    $(searchEngineSoldHistory.table).on('draw.dt', (e) => {
        $('.open-iframe').off('click');
        $('.open-iframe').click((e) => {
            let docEntry = $(searchEngineSoldHistory.table).DataTable().row(e.currentTarget.parentNode).data()['DocEntryVH'],
                iframe = document.getElementById('vh-folder-iframe'),
                callFunction = new CallFunction("folderModal", "fad fa-folder fa-3x");

            callFunction.modal.querySelector('.modal-dialog').style.height = "100%";
            callFunction.modal.querySelector('.modal-content').style.height = "100%";
            callFunction.modalHeader.classList.add('d-none');
            callFunction.modalBody.classList.remove('d-none');
            callFunction.modalBody.style.padding = '0';
            callFunction.modalBody.style.height = '100%';

            iframe.classList.remove('d-none');
            iframe.src = urls.vhFolder.replace(/toRpDocEntry/, docEntry) + '?noHeader=true';
            callFunction.modalBody.appendChild(iframe);

            $(callFunction.modal).modal('show');
            $(callFunction.modal).on('hidden.bs.modal', () => iframe.src = '');
        });
    });
}

// COLOR //

const initFolderColor = (vehicleFolder) => {
    let header = document.querySelector('.vh-header-nav');
    if (header) {
        header.style.borderBottom = '5px solid ' + vehicleFolder['CouleurRaisonSociale'];
        header.style.marginTop = '-4px';
        header.style.height = '55px';
    }
};

// PHOTO //

const initVehiclePhotos = (vehicle, vehicleFolder) => {
    let data = {resolution: "med"};

    appRequest(urls.getVehiclePhotos.replace('toRpRegistrationNumber', vehicle['U_W3C_NOIM']), data)
        .then(photos => {
            if (Object.keys(photos).length > 0) {
                displayHeaderPhotos(photos, vehicleFolder);
                displayTabPhotos(photos);
            } else {
                let photoContainer = document.getElementById('vh-photo');
                let statusPhotoProduct = vehicleFolder.hasOwnProperty('StatutPhotoProduct') ? vehicleFolder.StatutPhotoProduct : 'NO';
                let statusPhotoMisc = vehicleFolder.hasOwnProperty('StatutPhotoMisc') ? vehicleFolder.StatutPhotoMisc : 'NO';
                let statusPhotoDamages = vehicleFolder.hasOwnProperty('StatutPhotoDamages') ? vehicleFolder.StatutPhotoDamages : 'NO';
                let statusPhotoAll = getPointByStatus(statusPhotoProduct) * getPointByStatus(statusPhotoMisc) * getPointByStatus(statusPhotoDamages);
                let defaultImgContainer = document.createElement('div');
                let defaultCar = document.createElement('i');
                let defaultImg = document.createElement('div');
                let typeClass = 'warning';

                switch (statusPhotoAll) {
                    case 0:
                        typeClass = 'danger';
                        break;
                    case 9:
                        typeClass = 'success';
                        break;
                }

                defaultImgContainer.style.padding = '5px';
                defaultImgContainer.className = 'bg-' + typeClass;
                defaultImgContainer.style.right = '20px';
                defaultImgContainer.style.borderRadius = '6px';
                defaultImg.style.minHeight = '100%';
                defaultImg.className = 'bg-light text-center py-4';
                defaultCar.className = 'fad fa-car-mechanic fa-4x';
                defaultImg.appendChild(defaultCar);
                defaultImgContainer.appendChild(defaultImg);
                photoContainer.appendChild(defaultImgContainer);
            }
        });
};

const displayHeaderPhotos = (photos, vehicleFolder) => {

    let productPhotos = photos.hasOwnProperty("product") ? photos.product : false,
        prodb2bPhotos  = photos.hasOwnProperty("prodb2b") ? photos.prodb2b : false,
        damagesPhotos  = photos.hasOwnProperty("damages") ? photos.damages : false,
        displayablePhotos = false;

        if(productPhotos){
            displayablePhotos = productPhotos;
        } else if (prodb2bPhotos){
            displayablePhotos = prodb2bPhotos;
        } else {
            displayablePhotos = damagesPhotos;
        }

        let statusPhotoProduct = vehicleFolder.hasOwnProperty('StatutPhotoProduct') ? vehicleFolder.StatutPhotoProduct : 'NO',
        statusPhotoMisc = vehicleFolder.hasOwnProperty('StatutPhotoMisc') ? vehicleFolder.StatutPhotoMisc : 'NO',
        statusPhotoAll = getPointByStatus(statusPhotoProduct) * getPointByStatus(statusPhotoMisc);

    if (displayablePhotos) {
        let photoContainer = document.getElementById('vh-photo');
        let typeClass = 'warning';
        addGallery(photoContainer, displayablePhotos, true);
        switch (statusPhotoAll) {
            case 0:
                typeClass = 'danger';
                break;
            case 9:
                typeClass = 'success';
                break;
        }

        let nbPhotoProduct = photos.hasOwnProperty('product') ? Object.keys(photos.product).length : 0,
            nbPhotoProdb2b = photos.hasOwnProperty('prodb2b') ? Object.keys(photos.prodb2b).length : 0;
        document.getElementById('thumbnail_vehicle_folder').classList.add('bg-' + typeClass);
        document.getElementById('vh-photo-information').innerHTML =
            '<div class="rounded text-center text-white small font-weight-bold bg-' + typeClass + '">' +
            nbPhotoProduct +
            '<i class="fas fa-car ml-1 mr-4"></i>' + nbPhotoProdb2b + '<i class="fas fa-camera-alt ml-1"></i></div>';
    }
};

global.displayTabPhotos = (photos) => {
    function addSection(photosForGallery, type, createThumbnail = false) {
        let section = document.getElementById(type + 'Photo');
        addGallery(section.querySelector('.card-body'), photosForGallery, false, createThumbnail);
        hasPhoto = true
    }

    if (photos.hasOwnProperty('misc')) {
        addSection(photos.misc, 'misc');
    }

    if (photos.hasOwnProperty('product')) {
        addSection(photos.product, 'product');
    }

    if (photos.hasOwnProperty('prodb2b')) {
        addSection(photos.prodb2b, 'prodb2b');
    }

    if (photos.hasOwnProperty('misc2b')) {
        addSection(photos.misc2b, 'misc2b');
    }

    if (photos.hasOwnProperty('damages')) {
        addSection(photos.damages, 'damages');
    }

    if (photos.hasOwnProperty('interior')) {
        addSection(photos.interior, 'interior', true);
    }

    if (photos.hasOwnProperty('carBody')) {
        addSection(photos.carBody, 'carBody', true);
    }

    if (hasPhoto) {
        document.getElementById('photosVehicle').classList.remove('d-none');
    }
};

const addGallery = (container, photos, displayOnlyFirst, createThumbnail) => {
    let index = 0;

    for (let key of Object.keys(photos)) {
        let dNone = index !== 0 && displayOnlyFirst ? 'd-none' : '';

        if (key !== 'iframe_encrypt') {
            let img = createElement('img', 'img-thumbnail img-fluid border-0 ' + dNone);

            if (index === 0) {
                img.id = 'thumbnail_vehicle_folder';
            }

            img.src = photos[key];

            if (createThumbnail) {
                img.classList.add('thumbnail');
            }

            container.appendChild(img);
        }

        index++
    }

    const gallery = new Viewer(container);
    container.addEventListener("click", gallery.show)
};

// EQUIPMENT //

const initEquipmentOrderListener = () => {
    document.addEventListener('addTagForm', initEquipmentOrder)
};

const initEquipmentOrder = () => {
    let equipmentWeightElements = document.querySelectorAll('.equipment-weight');
    let equipmentWeightArray = Array.prototype.slice.call(equipmentWeightElements);
    let orderedElements = equipmentWeightArray.sort(sortEquipmentWeight);

    orderedElements.map(e => {
        e.addEventListener('change', initEquipmentOrder);
        e.parentElement.parentElement.appendChild(e.parentElement);
    });
};

const sortEquipmentWeight = (inputEquipmentA, inputEquipmentB) => {
    if (inputEquipmentA.value === "") return 1;
    if (inputEquipmentB.value === "") return -1;
    return inputEquipmentB.value - inputEquipmentA.value;
};


// TAB //

const initTab = (sections, targetTab) => {
    activeTab = targetTab;
    toggleSectionDisplay(activeTab, sections);
    [btnQuotation, btnAdmin, btnShipping, btnHistory, btnPhoto].map(element => {
        element.addEventListener('click', event => {
            event.preventDefault();
            if (activeTab === element.dataset.tab) return;
            activeTab = element.dataset.tab;
            toggleSectionDisplay(element.dataset.tab, sections);
            setActiveTab(element.dataset.tab);
            changeLink(activeTab);
        });
    });
};

const toggleSectionDisplay = (targetTab, sections) => {
    if (activeTab === 'history'){
        $('#load_vehicle_history').click();
    }
    if (activeTab === 'shipping'){
        $('#load_shipping_history').click();
    }
    sections.map(e => {
        if (targetTab === e.tab) {
            document.getElementById(e.id).classList.remove('d-none');
        } else {
            document.getElementById(e.id).classList.add('d-none');
        }
    })
};

const setActiveTab = (activeTab) => {
    let navContainer = document.getElementById('nav-container-vh');
    for (let i = 0; i < navContainer.children.length; i++) {
        let tab = navContainer.children[i].dataset.tab;

        if (activeTab === tab) {
            navContainer.children[i].classList.add('active');
            $.ajax({
                method: 'GET',
                url: urls.vehicleSaveTab.replace("toRpTab", activeTab)
            });
        } else {
            navContainer.children[i].classList.remove('active');
        }
    }
};

const changeLink = (activeTab) => {
    [btnNext, btnPrevious].map(e => {
        if (e === null) return;
        let url = new URL(e.href);
        url.searchParams.set('tab', activeTab);
        e.href = url.href;
    });
};

// CSA //

const initCsa = (vehicle) => {
    let btnAction = document.getElementById('vehicle_folder_administration_getCSA');
    let callFunction = new CallFunction("getCSA", "fad fa-file fa-3x");
    callFunction.modal.querySelector('.modal-dialog').style.height = "90%";
    callFunction.modal.querySelector('.modal-content').style.height = "100%";
    callFunction.modal.querySelector('.modal-body').style.height = "90%";
    btnAction.addEventListener('click', (event) => {
        event.stopPropagation();
        callFunction.showModal("Demande de certificat de situation administrative");
        callFunction.startLoading();
        let iframe = document.getElementById("csaIframe");
        if(document.getElementById("csaIframe").getAttribute("src") === null){
            callFunction.modalBody.appendChild(iframe);
        }
        iframe.classList.remove("d-none");
        let url = urls.getCSA.replace("toRpDocEntry", vehicle['DocEntry']);
        iframe.setAttribute("src", url);
        callFunction.stopLoading();
    })
};

export const vehicleFolderOpenPj = (url, titreModal) => {
    let callFunction = new CallFunction('vhFolderPj', 'fad fa-file fa-3x');
    callFunction.modal.querySelector('.modal-dialog').style.height = "90%";
    callFunction.modal.querySelector('.modal-content').style.height = "100%";
    callFunction.modal.querySelector('.modal-body').style.height = "90%";
    callFunction.showModal(titreModal);
    let iframe = document.createElement('iframe');
    iframe.style.width = '100%';
    iframe.style.height = '99%';
    iframe.setAttribute("src", url);
    callFunction.modalBody.appendChild(iframe);
};

export const adjustPercent = (numeratorFieldId, denominatorFieldId, ratioFieldId, immutableFieldId, initiatorFieldId) => {
    let numeratorValue = parseFloat(document.getElementById(numeratorFieldId).value),
        denominatorValue = parseFloat(document.getElementById(denominatorFieldId).value),
        ratioValue = parseFloat(document.getElementById(ratioFieldId).value);
    numeratorValue = isNaN(numeratorValue) ? 0 : numeratorValue;
    denominatorValue = isNaN(denominatorValue) ? 0 : denominatorValue;
    ratioValue = isNaN(ratioValue) ? 0 : ratioValue;
    if (denominatorValue == 0) {
        document.getElementById(ratioFieldId).value = '';
    } else {
        switch (initiatorFieldId) {
            case ratioFieldId:
                if (immutableFieldId == numeratorFieldId) {
                    document.getElementById(denominatorFieldId).value = Math.round(numeratorValue * 100 / ratioValue);
                } else if (immutableFieldId == denominatorFieldId) {
                    document.getElementById(numeratorFieldId).value = Math.round(ratioValue * denominatorValue / 100);
                } else {
                    // Cas impossible à gérer
                }
                break;
            case numeratorFieldId:
                if (immutableFieldId == numeratorFieldId) {
                    // normalement impossible à gérer mais on prend le parti de modifier le ratio
                    document.getElementById(ratioFieldId).value = Math.round(numeratorValue / denominatorValue * 100);
                } else if (immutableFieldId == denominatorFieldId) {
                    document.getElementById(ratioFieldId).value = Math.round(numeratorValue / denominatorValue * 100);
                } else {
                    document.getElementById(denominatorFieldId).value = Math.round(numeratorValue * 100 / ratioValue);
                }
                break;
            case denominatorFieldId:
                if (immutableFieldId == numeratorFieldId) {
                    document.getElementById(ratioFieldId).value = Math.round(numeratorValue / denominatorValue * 100);
                } else if (immutableFieldId == denominatorFieldId) {
                    // normalement impossible à gérer mais on prend le parti de modifier le ratio
                    document.getElementById(ratioFieldId).value = Math.round(numeratorValue / denominatorValue * 100);
                } else {
                    document.getElementById(numeratorFieldId).value = Math.round(ratioValue * denominatorValue / 100);
                }
                break;
        }
    }
}

const getPointByStatus = (status) => {
    switch (status) {
        case 'DONE':
        case 'NO':
            return 3;
        case 'TODO':
            return 1;
        case 'DOABLE':
            return 0;
        default:
            return 3;
    }
}

// ------- Argus -------

export const initArgusTable = (oidArgus, docEntry) => {
    let oidArgusInput = $('#oidArgusInput');
    $('.selectable-row tr').click(function () {
        let selectedArgusRowModel = $(this).children('td.argusModel');
        let selectedArgusRowOid = $(this).children('td.argusOid');
        let selectedArgusInput = $(this).children('th').children('div').children('input');

        selectedArgusInput.prop('checked', true);
        purgeArgusTableRowClass();
        $(this).addClass('bg-lightblue');
        oidArgusInput.attr('data-oid', selectedArgusInput.val());
        oidArgusInput.val(selectedArgusRowOid.html() + ' - ' + selectedArgusRowModel.html());
        $('#vehicle_folder_vehicleQuotation_oidArgus').val(selectedArgusRowOid.html());
        $('#argusSearchModal').modal('hide');
    });

    let argusQuotationButton = $('#argusQuotationButton');

    argusQuotationButton.on('click', function () {
        getQuote(docEntry);

        var $form = $(this).closest('form');
        var data = $form.serializeArray();

        $.ajax({
            url : urls.vhFolderEvent.replace('toRpDocEntry', docEntry).replace('toRpTriggerEvent', 'argus'),
            type: $form.attr('method'),
            data : data,
            success: function(html) {
                $('#quotation_history_table').replaceWith(
                    $(html).find('#quotation_history_table')
                );
            }
        });

    });

    $('#suggestedArgusVehicleTable').DataTable({
        "paging": false,
        "autoWidth": false,
        'ordering': false,
        "language": {
            "url": '../../translations/datatables/dataTables.french.json'
        }
    });

    addClassToCheckedArgusTableRow();
    if (oidArgus !== undefined){
        $('#suggestedArgusVehicleTable').find('td:contains(\''+oidArgus+'\')').parent().click();
    }
}


function getQuote(docEntry) {
    if (!docEntry){
        document.getElementById('customArgusFlashMessage').innerHTML = 'Impossible d\'effectuer l\'appel Argus. DocEntry du véhicule introuvable.';
        $("#customArgusFlashMessage").removeClass('d-none');
        return;
    }

    // Render flash message div invisible if not
    $("#customArgusFlashMessage:not(.hidden)").addClass('d-none')

    let argusQuotationButton = $('#argusQuotationButton');

    // Quotation inputs
    let argusStandardQuoteInput = $('#vehicle_folder_estimationQuotation_coteArgusStandard');
    let argusPersonalQuoteInput = $('#vehicle_folder_estimationQuotation_coteArgusPerso');
    let argusKilometersQuoteInput = $('#vehicle_folder_estimationQuotation_coteArgusKm');
    let argusInitialPriceInput = $('#vehicle_folder_estimationQuotation_prixNeufArgus');

    // Needed vehicle's inputs
    let vehicleTypeInput = $('#vehicle_folder_vehicleQuotation_typeVh');
    let vehicleTypeArgusInput = $('#vehicle_folder_vehicleQuotation_genreArgus');
    let oidArgusInput = $('#oidArgusInput');
    let registrationDateInput = $('#vehicle_folder_vehicleQuotation_dateDePmec');
    let registrationDateArgusInput = $('#vehicle_folder_vehicleQuotation_date1mecArgus');
    let mileageCounterInput = $('#vehicle_folder_vehicleQuotation_kilometrageCompteur');
    let declaredMileageInput = $('#vehicle_folder_vehicleQuotation_kilomdeclare');

    // If user make multi API call by clicking to the Argus quotation button, must to remove HTML class from previous click
    removeClassToHtmlTags(
        'border border-success border-danger shadow-success shadow-danger is-valid is-invalid',
        [
            argusStandardQuoteInput,
            argusPersonalQuoteInput,
            argusKilometersQuoteInput,
            argusInitialPriceInput,
            vehicleTypeInput,
            vehicleTypeArgusInput,
            oidArgusInput,
            registrationDateInput,
            registrationDateArgusInput,
            mileageCounterInput,
            declaredMileageInput
        ]
    );

    // Trigger loader icon
    argusQuotationButton.html('<i class="fas fa-spinner fa-pulse"></i><strong><em> Argus</em></strong>');

    if (checkNeededVehicleInputs(
        vehicleTypeInput,
        vehicleTypeArgusInput,
        oidArgusInput,
        registrationDateInput,
        registrationDateArgusInput,
        mileageCounterInput,
        declaredMileageInput
    )) {
        let data = {
            'type': !!vehicleTypeArgusInput.val() ? vehicleTypeArgusInput.val() : vehicleTypeInput.val(),
            'oid': oidArgusInput.attr('data-oid'),
            'registrationDate': !!registrationDateArgusInput.val() ? registrationDateArgusInput.val() : registrationDateInput.val(),
            'mileage': !!mileageCounterInput.val() && mileageCounterInput.val() !== '0' ? mileageCounterInput.val() : declaredMileageInput.val(),
            'docEntry': docEntry,
        }

        $.ajax({
            type: 'POST',
            data: data,
            url: urls.argusApiCall,
            success: function (response) {
                if (response.status === 'success') {
                    argusStandardQuoteInput.val(response.data.standardQuote);
                    argusPersonalQuoteInput.val(response.data.personalQuote);
                    argusKilometersQuoteInput.val(response.data.kilometersQuote);
                    argusInitialPriceInput.val(response.data.initialPrice);

                    addClassToHtmlTags(
                        'border border-success shadow-success',
                        [
                            argusStandardQuoteInput,
                            argusPersonalQuoteInput,
                            argusKilometersQuoteInput,
                            argusInitialPriceInput,
                        ]
                    );
                    argusQuotationButton.html('</i><strong><em>Argus</em></strong>');
                } else {
                    addClassToHtmlTags(
                        'border border-danger shadow-danger',
                        [
                            argusStandardQuoteInput,
                            argusPersonalQuoteInput,
                            argusKilometersQuoteInput,
                            argusInitialPriceInput,
                        ]
                    );
                    // Custom flash message is triggered here
                    document.getElementById('customArgusFlashMessage').innerHTML = response.message;
                    $("#customArgusFlashMessage").removeClass('d-none');

                    argusQuotationButton.html('<strong><em>Argus</em></strong>');
                }
            },
            error: function (response) {
            }
        });
    } else {
        addClassToHtmlTags(
            'border border-danger shadow-danger',
            [
                argusStandardQuoteInput,
                argusPersonalQuoteInput,
                argusKilometersQuoteInput,
                argusInitialPriceInput,
            ]
        );
        argusQuotationButton.html('<strong><em>Argus</em></strong>');
    }
}

function purgeArgusTableRowClass() {
    let argusTableRows = document.querySelectorAll("#suggestedArgusVehicleTable tbody tr")
    // Note : Must to make this kind of for loop instead a forEach cause Chrome 47 don't support it (from Chrome 51)
    // BUT, for some odd reasons, the Chrome 47 on ZZ_GROUPE_DEV env don't break on the forEach function ...
    for (let i = 0; i < argusTableRows.length; i++) {
        argusTableRows.item(i).classList.remove('bg-lightblue');
    }
}

function addClassToCheckedArgusTableRow() {
    let argusTableRowInputChecked = document.querySelector("#suggestedArgusVehicleTable tbody input:checked");
    if (argusTableRowInputChecked !== null) {
        let argusTableRow = argusTableRowInputChecked.parentElement.parentElement.parentElement;
        argusTableRow.classList.add('bg-lightblue')
    }
}

/**
 * Check if one or more of the provided inputs are empty or not
 *
 * @param vehicleTypeInput (type : HTML DOM element)
 * @param vehicleTypeArgusInput
 * @param oidArgusInput (type : HTML DOM element)
 * @param registrationDateInput (type : HTML DOM element)
 * @param registrationDateArgusInput
 * @param mileageCounterInput (type : HTML DOM element)
 * @param declaredMileageInput (type : HTML DOM element)
 *
 * @returns {boolean}
 */
function checkNeededVehicleInputs(
    vehicleTypeInput,
    vehicleTypeArgusInput,
    oidArgusInput,
    registrationDateInput,
    registrationDateArgusInput,
    mileageCounterInput,
    declaredMileageInput
) {
    let isValid = true;

    if (vehicleTypeArgusInput.val() === 0 || !vehicleTypeArgusInput.val()) {
        if (vehicleTypeInput.val() === 0 || !vehicleTypeInput.val()) {
            vehicleTypeInput.addClass('border border-danger shadow-danger');
            vehicleTypeArgusInput.addClass('border border-danger shadow-danger');
            isValid = false;
        }
    }

    if (!oidArgusInput.val()) {
        oidArgusInput.addClass('border border-danger shadow-danger');
        isValid = false;
    }

    if (!registrationDateInput.val() && !registrationDateArgusInput.val()) {
        registrationDateInput.addClass('border border-danger shadow-danger');
        registrationDateArgusInput.addClass('border border-danger shadow-danger');
        isValid = false;
    }

    let dummyMileageCounterValue = mileageCounterInput.val().replace(/\s+/g, '');
    let dummyDeclaredMileageValue = declaredMileageInput.val().replace(/\s+/g, '');

    if (!Number.isInteger(Number(dummyMileageCounterValue))
        || !dummyMileageCounterValue
        || Number(dummyMileageCounterValue) === 0
    ) {
        if (!Number.isInteger(Number(dummyDeclaredMileageValue))
            || !dummyDeclaredMileageValue
            || Number(dummyDeclaredMileageValue) === 0
        ) {
            declaredMileageInput.addClass('border border-danger shadow-danger');
            mileageCounterInput.addClass('border border-danger shadow-danger');
            isValid = false;
        }
    }

    return isValid;
}

/**
 * Allow to do what the element.addClass() do, but here with an array
 *
 * @param htmlClass (type : string)
 * @param htmlObjects (type : array of HTML DOM element)
 */
function addClassToHtmlTags(htmlClass, htmlObjects) {
    htmlObjects.forEach(element => element.addClass(htmlClass))
}

/**
 * Allow to do what the element.removeClass() do, but here with an array
 *
 * @param htmlClass (type : string)
 * @param htmlObjects (type : array of HTML DOM element)
 */
function removeClassToHtmlTags(htmlClass, htmlObjects) {
    htmlObjects.forEach(function(element) {
        element.removeClass(htmlClass)
    })
}


export const inputHelper = (value, preview, target) => {
    var $preview = $('#' + preview);
    var curStartPos = $preview[0].selectionStart;
    var curEndPos = $preview[0].selectionEnd;
    var curText = $preview.val();

    if (curStartPos > 0 && curText.charAt(curStartPos - 1) !== ' ') {
        value = ' ' + value;
    }
    if (curEndPos < curText.length && curText.charAt(curEndPos) !== ' ') {
        value = value + ' ';
    }
    $preview.val(curText.substring(0, curStartPos) + value + curText.substring(curEndPos));
    $('#' + target).val(curText.substring(0, curStartPos) + value + curText.substring(curEndPos));
}


export const checkImmat = (target) => {
    $.ajax({
        url : urls.checkImmatExists,
        type : 'GET',
        data : {
            immat : target.value,
            docEntry : $('#vehicle_folder_docEntry').val()
        },
        success : function (data, status){
            if (data['data']['exists']){
                $('#warning-immat').removeClass('d-none');
            } else {
                $('#warning-immat').addClass('d-none');
            }
        }
    })
};

export const checkMileage = (event) => {
    let kmDeclare = Number($('#vehicle_folder_registrationDocument_kilomdeclare').val().replace(' ',''));
    let kmSaisi = Number(event.value.replace(' ',''))
    if (kmSaisi > kmDeclare*1.05 || kmSaisi < kmDeclare*0.95){
        $('#mileage-modal').modal('show');
    }
};

export const assessmentCopy = (event) => {
    event.preventDefault();
    var $temp = $("<input>");
    $("body").append($temp);
    var url = $('#'+event.currentTarget.getAttribute('data-input-target')).val();
    if (url){
        // sap.sbo.webbridge.showSuccess('Ouverture de l\'url : '+url+' (Document d\'expertise)')
        sap.sbo.webbridge.showSuccess('Ouverture de l\'url : '+url)
    }
    $temp.val(url).select();
    document.execCommand("copy");
    $temp.remove();
}

export const createModelButton = (route) => {
    $('#vehicle_folder_vehicleQuotation_addModel').click((e) => {
        $(e.currentTarget).addClass('d-none');
        var $form = $('form[name=\'vehicle_folder\']');
        var data = $form.serializeArray();
        $.ajax({
            method: 'POST',
            url: route,
            data : data,
            success: function (response) {
                if (response['status'] === 'success') {
                    $('#vehicle_folder_vehicleQuotation_docentryModele').val(response['data']['docEntry']);
                    sap.sbo.webbridge.openForm('@W3C_MODELE', '' + response['data']['docEntry']);
                } else {
                    $('#flash').append($('<div/>', {
                        'class' : 'alert alert-danger my-0 px-2 py-1 cursor-pointer',
                        'data-dismiss' : 'alert',
                        'html' : response['message'],
                    }));
                }
                $(e.currentTarget).removeClass('d-none');
            },
            error: function (jqXHR, textStatus, errorThrown){
                $('#flash').append($('<div/>', {
                    'class' : 'alert alert-danger my-0 px-2 py-1 cursor-pointer',
                    'data-dismiss' : 'alert',
                    'html' : 'Impossible de créer le modèle :' + errorThrown,
                }));
                $(e.currentTarget).removeClass('d-none');
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/edit_vehicle.js